import { observer } from "mobx-react";
import moment from "moment";
import * as React from "react";

import DetailsPageFields, {
  FieldType as DetailsField,
} from "@client/components/modules/DetailsPage/Fields";
import { Licensor } from "@typings/Licensor";

type Props = {
  licensor: Licensor | null;
  role: string | null;
};

@observer
class DetailsFields extends React.Component<Props> {
  render() {
    const { licensor, role } = this.props;

    const fields: DetailsField[] = [
      {
        label: "Name",
        value: licensor?.name,
      },
      {
        label: "ID",
        value: licensor?.id,
      },
      {
        label: "Description",
        value: licensor?.description,
        showOnNull: true,
      },
      {
        label: "Created At",
        value:
          licensor?.created_at &&
          moment(licensor.created_at).format("DD MMM YYYY HH:mm"),
        showOnNull: true,
      },
      {
        label: "Email",
        value: licensor?.email,
      },
      {
        label: "Role",
        value: role,
        showOnNull: true,
      },
    ];

    return <DetailsPageFields fields={fields} />;
  }
}

export default DetailsFields;
